import { T } from 'gt-react';
import { ChatsCircleIcon } from '@phosphor-icons/react';
import { useNavigate } from '@tanstack/react-router';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { useCanViewFeedbackPage } from '@/hooks/useCanViewFeedbackPage';
import paths from '@/paths';

/** User-menu entry for the feedback page. */
export function FeedbackMenuItem() {
  const navigate = useNavigate();
  const canView = useCanViewFeedbackPage();
  if (!canView) return null;

  return (
    <DropdownMenuItem
      onClick={() => navigate({ to: paths.authenticated.feedbackTriage })}
    >
      <ChatsCircleIcon />
      <T context="user menu item: feedback page">Feedback</T>
    </DropdownMenuItem>
  );
}
